<template>
  <div class="container search-page">
    <h1 style="text-align: center" class="h1implantation">{{ menuTitle }}</h1>
    <div class="row">
      <div class="product-content">
        <div class="search-heading" style="text-transform: lowercase">
          <div class="result">{{ SearchCount }} {{ jumpdata.results }}</div>
          <div class="keyword">"{{ decodeURI(SearchKeyword) }}"</div>
        </div>
      </div>
      <div :class="filterColumnClass">
        <div class="filter-content-wrapper">
          <template v-if="smallScreen">
            <stickyelement>
              <div class="filter-bar">
                <span class="filters-title"
                  >{{ SearchCount }} {{ jumpdata.results }} {{ decodeURI(SearchKeyword) }}</span
                >
                <button class="filter-button" @click.prevent="openSidebarFilter()">
                  <svg class="icon">
                    <title>filter button</title>
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-filter"></use>
                  </svg>
                </button>
              </div>
            </stickyelement>
            <div class="sidebar-wrapper-filter" :class="{ toggled: sidebarFilterShown }">
              <div class="sidebar-wrapper">
                <div class="filters">
                  <div class="filter-header" :class="{ 'filter-header-fixed': filterHeaderFixed }">
                    <span class="filters-title"
                      >{{ SearchCount }} {{ jumpdata.results }} {{ decodeURI(SearchKeyword) }}</span
                    >
                    <button class="sidebar-close-filters" @click.prevent="closeSidebarFilter()">
                      <svg class="icon">
                        <title>close filter button</title>
                        <use
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="#close-sidebar-filters"
                        ></use>
                      </svg>
                    </button>
                  </div>
                  <template>
                    <div
                      :ref="section - 0"
                      :key="section - 0"
                      class="filter-section"
                      :class="{ 'filter-section--hidden': !sidebarFilterShown }"
                    >
                      <div
                        :ref="trigger - 0"
                        class="filter-section--header"
                        tabindex="0"
                        aria-expanded="false"
                        role="button"
                        @click.prevent="handleClick(index)"
                        @focus="handleFocus(index)"
                        @focusout="handleFocusOut(index)"
                      >
                        <h2 class="filter-section--header--title">
                          {{ decodeURI(SearchKeyword) }}
                        </h2>
                        <span class="filter-section--header--status"></span>
                      </div>
                      <div
                        :ref="collapsable - 0"
                        class="filter-section--list-wrapper"
                        aria-hidden="true"
                      >
                        <ul class="filter-section--list">
                          <li style="cursor: pointer" @click="clickproductRange()">
                            <span class="checkbox">
                              <input id="check1" type="checkbox" style="display: none" />
                              <label for="check1">{{ jumpdata.product_range }}</label>
                            </span>
                          </li>
                          <li style="cursor: pointer" @click="clickProduct()">
                            <span class="checkbox">
                              <input id="check2" type="checkbox" style="display: none" />
                              <label for="check2">{{ jumpdata.products }}</label>
                            </span>
                          </li>
                          <li style="cursor: pointer" @click="clickArticle()">
                            <span class="checkbox">
                              <input id="check3" type="checkbox" style="display: none" />
                              <label for="check3">{{ jumpdata.articles }}</label>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <overlay></overlay>
            </div>
          </template>
          <template v-if="!smallScreen">
            <div v-sticky-filters class="filter-wrapper">
              <div class="filters">
                <div :ref="section - 0" class="filter-section">
                  <div
                    :ref="trigger - 0"
                    tabindex="0"
                    aria-expanded="true"
                    role="button"
                    class="filter-section--header"
                  >
                    <h2 class="filter-section--header--title">{{ jumpdata.jumpto }}</h2>
                    <span class="filter-section--header--status"></span>
                  </div>
                  <div
                    :ref="collapsable - 0"
                    aria-hidden="false"
                    class="filter-section--list-wrapper"
                  >
                    <ul class="filter-section--list">
                      <li @click="clickproductRange()">
                        <span class="checkbox">
                          <input id="check1" type="checkbox" />
                          <label for="check1">{{ jumpdata.product_range }}</label>
                        </span>
                      </li>
                      <li @click="clickProduct()">
                        <span class="checkbox">
                          <input id="check2" type="checkbox" />
                          <label for="check2">{{ jumpdata.products }}</label>
                        </span>
                      </li>
                      <li @click="clickArticle()">
                        <span class="checkbox">
                          <input id="check3" type="checkbox" />
                          <label for="check3">{{ jumpdata.articles }}</label>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="Total_Count != 0" :class="productColumnClass" class="grid-wrapper">
        <div
          v-if="
            !prsearchdata.ProductRange_Count &&
            !productssearchdata.Product_Count &&
            !articlessearchdata.Article_Count
          "
        >
          <div class="text-center">
            <svg class="icon spinner">
              <title>Spinner</title>
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spinner"></use>
            </svg>
          </div>
        </div>
        <div v-else>
          <div id="content1">
            <div v-if="truncatedFilteredProductRange != ''">
              <h2 class="filter-section--header--title">
                {{ jumpdata.product_range }} ({{ prsearchdata.ProductRange_Count }})
              </h2>
              <ul class="grid">
                <li v-for="(productrange, index) in truncatedFilteredProductRange" :key="index">
                  <article>
                    <div class="product-item">
                      <span
                        :class="[
                          'product-badge plp',
                          productrange.productbadgtext ? '' : 'hide-badge',
                        ]"
                        >{{ productrange.productbadgtext }}</span
                      >
                      <div class="product-item-box">
                        <div class="product-item-info">
                          <a style="cursor: pointer" :href="productrange.FilterUrl">
                            <div v-if="productrange.FilterImage !== null">
                              <img :src="productrange.FilterImage.Src" alt="" />
                            </div>
                            <div v-else></div>
                            <div class="product-item-info">
                              <h3 class="product-name">
                                {{ productrange.FilterTitle.replace(/&amp;#39;/g, "'") }}
                              </h3>
                              <p class="product-description">
                                {{ productrange.FilterDescription.replace(/&amp;#39;/g, "'") }}
                              </p>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </article>
                </li>
              </ul>
              <div class="load-more-container">
                <div v-if="!allProductRange">
                  <button
                    v-if="prsearchdata.ProductRange_Count > 3"
                    class="load-more ripple-animation ripple-animation--white"
                    @click="showMoreproductrange()"
                  >
                    <span>{{ rangeloadMore }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <h2 class="filter-section--header--title">
                {{ jumpdata.product_range }} ({{ prsearchdata.ProductRange_Count }})
              </h2>
              <p>{{ noProducts }}</p>
            </div>
          </div>
          <div id="content2">
            <div v-if="truncatedFilteredProduct.length != 0">
              <h2 class="filter-section--header--title">
                {{ jumpdata.products }} ({{ productssearchdata.Product_Count }})
              </h2>
              <ul class="grid">
                <li
                  v-for="(product, index) in truncatedFilteredProduct"
                  :key="product.ProductID"
                  @click="productClicked(product, index)"
                >
                  <article>
                    <div class="product-item">
                      <span
                        :class="['product-badge plp', product.productbadgtext ? '' : 'hide-badge']"
                        >{{ product.productbadgtext }}</span
                      >
                      <div class="product-item-box">
                        <div class="product-item-info">
                          <a style="cursor: pointer" :href="product.ProductUrl">
                            <div>
                              <media-searchimage
                                :filename="product.image.filename"
                                :resolutions="product.image.resolutions"
                                :alt="product.image.alt"
                                :sizes="product.image.sizes"
                                :fallback-size="product.image['fallback-size']"
                                :lazy="true"
                                :ratio="product.image.ratio"
                              >
                              </media-searchimage>
                            </div>
                            <div class="product-item-info">
                              <h3 class="product-name">
                                {{ product.ProductName.replace(/&amp;#39;/g, "'") }}
                              </h3>
                              <p class="product-description">
                                {{ product.ProductDescription.replace(/&amp;#39;/g, "'") }}
                              </p>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </article>
                </li>
              </ul>
              <div class="load-more-container">
                <div v-if="!allLoadedproduct">
                  <button
                    v-if="productssearchdata.Product_Count > 3"
                    style="border: 1px solid grey"
                    class="load-more ripple-animation ripple-animation--white"
                    @click="showMoreproduct()"
                  >
                    <span>{{ productsloadMore }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <h2 class="filter-section--header--title">
                {{ jumpdata.products }} ({{ productssearchdata.Product_Count }})
              </h2>
              <p>{{ noProducts }}</p>
            </div>
          </div>
          <div id="content3">
            <div v-if="truncatedFilteredArticle != ''">
              <h2 class="filter-section--header--title">
                {{ jumpdata.articles }} ({{ articlessearchdata.Article_Count }})
              </h2>
              <ul class="grid">
                <li v-for="article in truncatedFilteredArticle" :key="article.ArticleID">
                  <article>
                    <div class="product-item">
                      <div class="product-item-box">
                        <div class="product-item-info">
                          <a style="cursor: pointer" :href="article.ArticleUrl">
                            <div>
                              <img :src="article.image.Src" alt="" />
                            </div>
                            <div class="product-item-info">
                              <h3 class="product-name">
                                {{ article.title.replace(/&amp;#39;/g, "'") }}
                              </h3>
                              <p class="product-description">
                                {{ article.summary.replace(/&amp;#39;/g, "'") }}
                              </p>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </article>
                </li>
              </ul>
              <div class="load-more-container">
                <div v-if="!allLoadedarticle">
                  <button
                    v-if="articlessearchdata.Article_Count > 3"
                    style="border: 1px solid grey"
                    class="load-more ripple-animation ripple-animation--white"
                    @click="showMorearticle()"
                  >
                    <span>{{ jumpdata.showmore_articles }}</span>
                  </button>
                </div>
                <div v-else></div>
              </div>
            </div>
            <div v-else>
              <h2 class="filter-section--header--title">
                {{ jumpdata.articles }} ({{ articlessearchdata.Article_Count }})
              </h2>
              <p>{{ noProducts }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>{{ noProducts }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'searchfilter',
  props: {
    filterColumnClass: { type: String, required: false, default: 'col-sm-3' },
    productColumnClass: { type: String, required: false, default: 'col-sm-9' },
    noProducts: { type: String },
    menuTitle: { type: String },
  },
  data() {
    return {
      sidebarFilterShown: false,
      filterHeaderFixed: false,
      smallScreen: window.ScreenSizeHandler
        ? window.ScreenSizeHandler.getMqForSize('small').selected
        : true,
      allProductRange: false,
      allLoadedproduct: false,
      allLoadedarticle: false,
      imagesLimitproductranges: 3,
      imagesLimitproduct: 3,
      imagesLimitarticle: 3,
      SearchKeyword: '',
      prsearchdata: '',
      productssearchdata: '',
      articlessearchdata: '',
      truncatedFilteredProductRange: '',
      truncatedFilteredProduct: '',
      truncatedFilteredArticle: '',
      jumpdata: JSON.parse(localStorage.getItem('jumpdata')) || '',
      rangeloadMore: '',
      productsloadMore: '',
      articlesloadMore: '',
      activeSection: null,
      activeTrigger: null,
      activeCollapsable: null,
      index: 0,
      SearchCount: '',
    };
  },
  computed: {
    Total_Count() {
      if (this.prsearchdata && this.productssearchdata && this.articlessearchdata) {
        return (
          this.prsearchdata.ProductRange_Count +
          this.productssearchdata.Product_Count +
          this.articlessearchdata.Article_Count
        );
      }
      return -1;
    },
  },
  watch: {
    Total_Count(count) {
      if (count < 0) {
        return;
      }
      this.SearchCount = count;
      dataLayer.forEach((el, index) => {
        if (el.searchCategory === 'internal search') {
          dataLayer[index]['searchKeyword'] = decodeURI(this.SearchKeyword);
          dataLayer[index]['numberResults'] = this.SearchCount || 0;
        }
      });
      this.$forceUpdate();
    },
  },
  created() {
    const currentURL = window.location.href.split('=');
    this.SearchKeyword = currentURL[currentURL.length - 1];
    this.loadData();
  },
  mounted() {
    if (localStorage.getItem('jumpdata')) {
      this.jumpdata = JSON.parse(localStorage.getItem('jumpdata'));
    }

    this.$nextTick(() => {
      this.activeSection = this.$refs[`section-${this.index}`];
      this.activeTrigger = this.$refs[`trigger-${this.index}`];
      this.activeCollapsable = this.$refs[`collapsable-${this.index}`];
    });

    const that = this;
    if (window) {
      /* istanbul ignore next */
      window.eventBus.$on('sidebarFilter.toggled', (value) => {
        that.sidebarFilterShown = value;
        /* delay a little bit to switch filter-header from position abs to fixed */
        document.querySelector('body').classList.remove('no-scroll');
        setTimeout(() => {
          // this.filterHeaderFixed = value
          if (document.querySelector('.sidebar-wrapper-filter.toggled') != null) {
            document.querySelector('.sidebar-wrapper-filter.toggled').style.position = 'absolute';
            document.querySelector('.sidebar-wrapper-filter.toggled').style.top =
              'calc(-100% - 52px)';
          }
        }, 400);
      });
    }
    this.searchDataLayerPush();
  },
  beforeDestroy() {
    if (window) {
      window.addEventListener('beforeunload', () => {
        localStorage.removeItem('jumpdata');
      });
    }
  },
  methods: {
    productClicked(product, index) {
      const productClickTag = {
        event: 'productClick',
        eventCategory: 'Ecommerce',
        event_name: 'select_item',
        eventAction: 'Product Click',
        eventLabel: product.ProductName.toLowerCase() + '::' + product.ProductEAN,
        product_info: product.ProductName.toLowerCase() + '::' + product.ProductEAN,
        ecommerce: {
          click: {
            actionField: [],
            list: 'list-result-range',
            products: {
              name: product.ProductName.toLowerCase(),
              id: product.ProductEAN || '',
              price: product.ProductPrice || 'none',
              brand: 'KER',
              category: product.ProductsTag.toLowerCase() || 'none',
              position: (index + 1).toString(),
              dimension35: product.ProductQuantity || 'none',
              dimension36: 'none',
              dimension38: product.TotalReviewCount || 'none',
              dimension48: product.ProductEAN,
              dimension59: product.TotalReviewCount,
              dimension91: 'none',
            },
          },
        },
      };
      window.dataLayer.push(productClickTag);
    },
    loadData() {
      this.productsRangeSearch();
      this.productsSearch();
      this.articlesSearch();
    },
    searchDataLayerPush() {
      setTimeout(() => {
        window.dataLayer.push({
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'internal search',
          eventAction: 'search::manual',
          eventLabel: this.SearchKeyword,
          event_name: 'internal_search',
          search_keyword: this.SearchKeyword,
          method: 'manual',
        });
      }, 2000);
    },
    productsRangeSearch() {
      axios
        .get(`api/productsrangesearch/query?query=${this.SearchKeyword}`)
        .then((response) => {
          this.prsearchdata = response.data;
          this.rangeloadMore = this.prsearchdata.search_data.showmore_products;
          const filteredRange = this.prsearchdata.productsrange
            ? this.prsearchdata.productsrange.slice(0, this.imagesLimitproductranges)
            : '';
          this.truncatedFilteredProductRange = filteredRange;
          if (localStorage.getItem('jumpdata')) {
            this.jumpdata = JSON.parse(localStorage.getItem('jumpdata'));
          } else {
            this.jumpdata = this.prsearchdata.search_data;
            const parsed = JSON.stringify(this.prsearchdata.search_data);
            localStorage.setItem('jumpdata', parsed);
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    productsSearch() {
      axios.get(`api/productssearch/query?query=${this.SearchKeyword}`).then((response) => {
        this.productssearchdata = response.data;
        this.productsloadMore = this.productssearchdata.search_data.showmore_products;
        const filteredProduct = this.productssearchdata.products
          ? this.productssearchdata.products.slice(0, this.imagesLimitproduct)
          : '';
        this.truncatedFilteredProduct = filteredProduct;

        /// PRODUCT IMPRESSIONS - SEARCH RESULTS PAGE
        const impressions = [];
        this.truncatedFilteredProduct.forEach((item, index) => {
          if (Object.keys(item).length) {
            impressions.push({
              name: item.ProductName.toLowerCase(),
              id: item.ProductEAN || 'none',
              price: item.ProductPrice || 'none',
              brand: 'KER',
              category: item.ProductsTag != null ? item.ProductsTag.toLowerCase() : 'none',
              list: 'list-result-range',
              position: (index + 1).toString(),
              dimension35: item.ProductQuantity || 'none',
              dimension36: 'none',
              dimension38: item.TotalReviewCount || 'none',
              dimension48: item.ProductEAN || 'none',
              dimension59: item.TotalReviewCount,
              dimension91: 'none',
            });
          }
        });
        try {
          dataLayer.push({
            event: 'nievent',
            event_name: 'view_item_list',
            eventCategory: 'Ecommerce',
            eventAction: 'Product Impressions',
            eventLabel: 'internal search',
            ecommerce: {
              currencyCode: 'none',
              impressions: [],
              product: impressions,
            },
          });
        } catch {
          console.warn('datalayer is not defined');
        }
      });
    },
    articlesSearch() {
      axios
        .get(`api/articlessearch/query?query=${this.SearchKeyword}`)
        .then((response) => {
          this.articlessearchdata = response.data;
          this.articlesloadMore = this.articlessearchdata.search_data.showmore_products;
          const filteredArticle = this.articlessearchdata.articles
            ? this.articlessearchdata.articles.slice(0, this.imagesLimitarticle)
            : '';
          this.truncatedFilteredArticle = filteredArticle;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    clickproductRange() {
      const elmnt1 = document.querySelector('#content1');
      window.scroll({ top: elmnt1.offsetTop, behavior: 'smooth' });
    },
    clickProduct() {
      const elmnt2 = document.querySelector('#content2');
      window.scroll({ top: elmnt2.offsetTop, behavior: 'smooth' });
    },
    clickArticle() {
      const elmnt3 = document.querySelector('#content3');
      window.scroll({ top: elmnt3.offsetTop, behavior: 'smooth' });
    },
    showMoreproductrange() {
      this.imagesLimitproductranges += this.prsearchdata.productsrange.length - 1;
      if (this.imagesLimitproductranges >= this.prsearchdata.productsrange.length) {
        this.imagesLimitproductranges = this.prsearchdata.productsrange.length;
        this.truncatedFilteredProductRange = this.prsearchdata.productsrange.slice(
          0,
          this.imagesLimitproductranges,
        );
        this.allProductRange = true;
      }
    },
    showMoreproduct() {
      this.imagesLimitproduct += this.productssearchdata.products.length - 1;
      if (this.imagesLimitproduct >= this.productssearchdata.products.length) {
        this.imagesLimitproduct = this.productssearchdata.products.length;
        this.truncatedFilteredProduct = this.productssearchdata.products.slice(
          0,
          this.imagesLimitproduct,
        );
        this.allLoadedproduct = true;
      }
    },
    showMorearticle() {
      this.imagesLimitarticle += this.articlessearchdata.articles.length - 1;
      if (this.imagesLimitarticle >= this.articlessearchdata.articles.length) {
        this.imagesLimitarticle = this.articlessearchdata.articles.length;
        this.truncatedFilteredArticle = this.articlessearchdata.articles.slice(
          0,
          this.imagesLimitarticle,
        );
        this.allLoadedarticle = true;
      }
    },
    openSidebarFilter() {
      if (window.eventBus) {
        window.eventBus.$emit('sidebarFilter.toggled', true);
      }
    },
    closeSidebarFilter() {
      if (window.eventBus) {
        window.eventBus.$emit('sidebarFilter.toggled', false);
      }
    },
  },
};
</script>
